<template>
  <div v-if="loaded">
    <div class="table_sec">
      <div class="md-layout-item md-size-100 page">
        <div class="section_body">
        <div class="tble-box">
          <div class="tbl-title">
            <h4>Dollars</h4>
          </div>
          <div class="inner-tbl">
                                  <md-table
                                  v-model="tableDataIndustryDollar"
                                  table-header-color="blue"
                                  class="dark_blue"
                                  style="flex: 1;"
                                  >
                                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                                        <md-table-cell
                                          md-label="Parameters"
                                          :class="item.name === 'Cost of Sales - Labor Portion'
                                          ? 'md-table-side-label pl-2'
                                          : 'md-table-side-label'"
                                        >
                                          {{ item.name }}
                                          <md-tooltip md-direction="bottom">
                                            {{
                                              item.rollover
                                            }}
                                          </md-tooltip>
                                        </md-table-cell>

                                        <!-- <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options"
                                            chart-type="Line"
                                            header-icon
                                            chart-inside-content
                                            no-footer
                                            background-color="blue"
                                          ></chart-card>
                                        </md-table-cell> -->

                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                        >${{ item.dates[key] }}</md-table-cell>
                                      </md-table-row>
                                    </md-table>
          </div>

        </div>
        <p class="common_footer footer-formatting">Copyright © 2022 Bizminer. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
// import { NavTabsCard, ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';

export default {
  components: {
    // ChartCard,
  },
  mixins: [formatData],
  data() {
    return {
      view: 'dollar',
      tableDataIndustryDollar: [],
      tableDataIndustryPercent: [],
      tableDataFirmDollar: [],
      tableDataFirmPercent: [],
      tableDataVarianceDollar: [],
      charts: [],
      loaded:false,
      options: {
        showLabel: false,
        legendNames: [],
        height: '250px',
      },
      display_by_dollars: false,
      display_by_percentages: false,
      display_by_variance: false,
      colouredLineChart: {
        data: {
          labels: [1, 2, 3, 4, 5],
          series: [
            [1, 5, 3, 4, 2]
          ]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 1,
          }),
          chartPadding: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
          },
          axisY: {
            showGrid: false,
            showLabel: false,
            offset: 0,
          },
          axisX: {
            showGrid: false,
            showLabel: false,
            offset: 0,
            scaleMinSpace: 6
          },
          showPoint: true,
          showLabel: false,
          width: "100px",
          height: "25px",
          seriesBarDistance: 10,
          fullWidth: true,
        },
      },
    };
  },
  computed: {
    ...mapState({
      chartData: (state) => state.user.profile.data.chartData['profitLoss'],
      table: (state) => state.user.profile.data.tables['PL'],
      showYears: (state) => state.user.profile.data.showYears,
      years: (state) => state.user.profile.data.years,
      report: (state) => state.user.profile.data,
      isSPIF: (state) => state.user.profile.spif,
      profile: (state) => state.user.profile,
    }),
  },
  mounted() {
    this.init();
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'dollar';
      }

      this.switchView(section);
    },
     sourceYears(newVal, oldVal) {
      if (this.sourceTablesInfo && newVal) {
       Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
        this.$set(this, table, this.formatSourcesData(table, data))
      );
      }
    },

    profile(newVal, oldVal) {
      this.init();
    }
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
    getOptions(newOptions) {
      return {
        ...this.options,
        ...newOptions,
      };
    },
    init() {
         this.$store.commit(
      'user/SET_ACTIVE_SECTION',
      'Profit & Loss'
    );

    let section = this.$route.query.section;

    if (!section) {
      section = 'dollar';
    }

    if (!this.report) {
      return;
    }

    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = true;
      this.display_by_percentages = true;
      // this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_dollar') &&
      !this.report.displaySettings.includes('pl_balance_percent')
    ) {
      this.display_by_dollars = true;
      // this.display_by_variance = true;
    }
    if (
      this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_percentages = true;
      // this.display_by_variance = true;
    }
    if (
      !this.report.displaySettings.includes('pl_balance_percent') &&
      !this.report.displaySettings.includes('pl_balance_dollar')
    ) {
      this.display_by_dollars = false;
      this.display_by_percentages = false;
      // this.display_by_variance = false;
    }
    this.switchView(section);
    let filtered_years = [];
    Object.keys(this.showYears).forEach((k, i) => {
      if (this.showYears[k]) {
        filtered_years.push(this.years[i]);
      }
    });
    if (!filtered_years.length) {
      filtered_years = this.years;
    }

    this.tableDataIndustryDollar = this.formatTable(
      this.table,
      'industry',
      'dollar'
    );
    this.tableDataIndustryDollar = this.tableDataIndustryDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.tableDataIndustryPercent = this.formatTable(
      this.table,
      'industry',
      'percent'
    );
    this.tableDataIndustryPercent = this.tableDataIndustryPercent.map(
      (item) => {
        let changeDates = Object.keys(item.dates);
        changeDates = changeDates.filter((fItem) => {
          return !filtered_years.includes(fItem);
        });
        let newDates = item.dates;
        changeDates.map((el) => {
          delete newDates[el];
        });
        let obj = {
          ...item,
          dates: newDates,
        };

        return obj;
      }
    );

    this.tableDataFirmDollar = this.formatTable(this.table, 'firm', 'dollar');
    this.tableDataFirmDollar = this.tableDataFirmDollar.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.tableDataFirmPercent = this.formatTable(this.table, 'firm', 'percent');
    this.tableDataFirmPercent = this.tableDataFirmPercent.map((item) => {
      let changeDates = Object.keys(item.dates);
      changeDates = changeDates.filter((fItem) => {
        return !filtered_years.includes(fItem);
      });
      let newDates = item.dates;
      changeDates.map((el) => {
        delete newDates[el];
      });
      let obj = {
        ...item,
        dates: newDates,
      };

      return obj;
    });

    this.charts = this.formatPieChart(this.chartData);
     this.loaded = true;
    }
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.loading {
  position: absolute;
  left: 45%;
  // left: calc(45% / 2);
}
</style>
